// A mountain goat, modelled facing +X: a shaggy white body on sturdy legs, a
// bearded head and back-curving horns. Ported 1:1 from age-of-mcp's classic
// mountain-goat.ts, restoring its leg loop + body/head/beard/horn composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.05, 0.028], [0.05, -0.028], [-0.05, 0.028], [-0.05, -0.028]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.007, 0.006, 0.1, 4),
      color: "#cfc8bc", position: [x!, 0.05, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#eef0ec",
      position: [0, 0.1, 0], scale: [1.7, 1, 0.95] },                // shaggy body
    { geometry: new THREE.IcosahedronGeometry(0.025, 0), color: "#f4f6f2",
      position: [0.088, 0.1, 0], scale: [1.2, 1.1, 0.9] },           // head
    { geometry: new THREE.ConeGeometry(0.012, 0.03, 4), color: "#dcdcd4",
      position: [0.095, 0.07, 0], rotation: [Math.PI, 0, 0] },        // beard
    { geometry: new THREE.ConeGeometry(0.006, 0.04, 4), color: "#2a2620",
      position: [0.078, 0.13, 0.014], rotation: [0, 0, -0.5] },       // horn
    { geometry: new THREE.ConeGeometry(0.006, 0.04, 4), color: "#2a2620",
      position: [0.078, 0.13, -0.014], rotation: [0, 0, -0.5] },
  );
  return parts;
}

export const mountainGoat = defineModel({
  id: "mountain-goat",
  scale: 2.66, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Mountain goat",
  tags: ["creature","mountain","goat","low-poly","age-of-mcp","classic"],
  summary: "Low-poly mountain goat.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.13,
  parts: () => partsFor(),
  animations: [],
});
